export const GET_HAD_NOTIFICATION_START = 'GET_HAD_NOTIFICATION_START';

export const GET_HAD_NOTIFICATION_SUCCESS = 'GET_HAD_NOTIFICATION_SUCCESS';

export const GET_HAD_NOTIFICATION_FAILURE = 'GET_HAD_NOTIFICATION_FAILURE';
